import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

export const darkTheme = createTheme({
    palette: {
        mode: "dark",
        background: {
            paper: '#191919',
            default: '#000',
            medium: '#999',
            shadow: '#999'
        },
        waterGreen: {
            light: '#E2EFD9',
            main: '#8A9C7D',
            dark: '#C6DFB4',
        },
        waterBlue: {
            light: '#EBF0F8',
            main: '#ACB4C1',
            dark: '#D8E1F2',
        },
        waterOrange: {
            light: '#FCE8DE',
            main: '#C9B5AB',
            dark: '#FCE3D6',
        },
        customRed: {
            light: red[300],
            main: red[700],
            dark: red[500],
        },
        customGrey: {
            light: '#D9D7D7',
            main: '#A6A4A4',
            dark: '#D0CDCE',
        },
        tertiary: {
            main: "#22510B",
            contrastText: "#fff",
            light: '#7766ff', // Variação mais clara
            dark: '#1100cc',  // Variação mais escura
        },
    }
});